import * as React from 'react';

export interface IArticleListPagerBtnProps {
    page: number,
    isActive: boolean,
    pageBtnHandler(page: number): void
}

export class ArticleListPagerBtn extends React.Component<IArticleListPagerBtnProps, {}>{
    render() {
        return (
            <small className={'pagination-pages-item' + (this.props.isActive ? ' active' : '')} 
                onClick={() => this.props.pageBtnHandler(this.props.page)}>
                {this.props.page}
            </small>
        );
    }
}


// WEBPACK FOOTER //
// ./~/source-map-loader!./app/src/shared/article-list-pager-btn.tsx